import { useField } from 'formik'
import { FieldConfig } from 'formik/dist/Field'
import { DatePicker } from 'common/DatePicker/DatePicker'
import Styles from './DatePickerField.module.scss'

interface DatePickerFieldProps {
  value: string
  onChange: (value: string) => void
  errorMessage?: string
  className?: string
  label?: string
  isDisabled?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export const DatePickerField = ({
  value,
  onChange,
  errorMessage,
  className,
  label,
  isDisabled,
  size = 'md',
}: DatePickerFieldProps) => {
  return (
    <div className={className}>
      {label && <label className={Styles.label}>{label}</label>}
      <div className={Styles.datePickerField}>
        <DatePicker
          value={value}
          onChange={(next) => onChange(next ?? '')}
          onDeleted={() => onChange('')}
          readOnly={isDisabled}
          size={size}
        />
        {errorMessage && <div className={Styles.errorMessage}>{errorMessage}</div>}
      </div>
    </div>
  )
}

interface FormikDatePickerFieldProps {
  className?: string
  label?: string
  size?: 'sm' | 'md' | 'lg'
  isDisabled?: boolean
}

export const FormikDatePickerField = (props: FormikDatePickerFieldProps & Omit<FieldConfig<string>, 'onChange'>) => {
  const [field, meta, { setValue }] = useField<string>({ name: props.name })
  const displayError = meta.touched && meta.error
  return (
    <DatePickerField
      value={field.value || ''}
      onChange={(value) => setValue(value)}
      errorMessage={displayError ? meta.error : undefined}
      className={props.className}
      label={props.label}
      size={props.size}
      isDisabled={props.isDisabled}
    />
  )
}
